import { toast } from '@companion-professional/components';

export const copyTextToClipboard = (text?: string, successText = 'Request URL copied to clipboard') => {
  if (!text) {
    console.error('Unable to copy empty text.');
    return;
  }

  navigator.clipboard
    .writeText(text)
    .then(() => {
      toast(successText, {
        description: text
      });
    })
    .catch((err) => {
      console.error('Could not copy text: ', err);
    });
};
